module.exports = __webpack_public_path__ + "img/3.a129c1b2.jpg";